import { render } from "./SpaTreatmentBooking.vue?vue&type=template&id=37b79283"
import script from "./SpaTreatmentBooking.vue?vue&type=script&lang=js"
export * from "./SpaTreatmentBooking.vue?vue&type=script&lang=js"

import "@/css/booking/booking.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__